import isEmpty from 'lodash/isEmpty';
import { isBrowser } from './utils';
import { PES_USER } from '@pes-ui/utils';
const createQueries = (params) => {
  let queryString = '';
  for (const key in params) {
    if (params && params.hasOwnProperty(key)) {
      queryString += `&${key}=${params[key]}`;
    }
  }
  return queryString.slice(1);
};
export const addParams = (url, params = {}) => {
  if (!isEmpty(params)) {
    return `${url}${url.includes('?') ? '&' : '?'}${createQueries(params)}`;
  }
  return url;
};
export const request = (url, params = {}) => {
  return fetch(url, Object.assign(Object.assign({ method: 'GET', mode: 'cors' }, params), { headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    } })).then((response) => {
    if (response.status >= 200 && response.status < 300) {
      return response.json();
    }
    throw response.status;
  });
};
export const http = {
  post(url, params = {}, requestConfig) {
    const requestInit = Object.assign(Object.assign({}, requestConfig), { method: "POST" });
    if (!isEmpty(params)) {
      requestInit.body = JSON.stringify(params);
    }
    return request(url, requestInit);
  },
  delete(url, params = {}, requestConfig) {
    return request(addParams(url, params), Object.assign(Object.assign({}, requestConfig), { method: "DELETE" }));
  },
  get(url, params = {}, requestConfig) {
    return request(addParams(url, params), requestConfig);
  },
};
export const makeGetData = () => (data, rest, authorization) => {
  if (data) {
    return new Promise((resolve) => resolve(data));
  }
  const header = {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  };
  const userToken = sessionStorage.getItem(PES_USER.TOKEN_KEY);
  if (userToken)
    header['User-Authorization'] = userToken;
  if (authorization) {
    header.Autorization = authorization;
  }
  if (rest && isBrowser()) {
    return fetch(rest, {
      method: 'GET',
      mode: 'cors',
      headers: header,
    }).then((response) => {
      if (response.status === 200) {
        return response.json();
      }
      throw response.status;
    });
  }
  return new Promise((resolve) => resolve(null));
};
export const getData = makeGetData();
